import { EffectCallback, useEffect } from 'react';

/**
 * Fires a callback once after the component first mounts (its first render).
 *
 * This is not called useComponentDidMount because the timing is slightly
 * different (later) than the old componentDidMount lifecycle method:
 * https://reacttraining.com/blog/useEffect-is-not-the-new-componentDidMount/
 *
 * Note that this hook does *not* guarantee that the effect will only be called
 * once. In particular, in dev mode, these effects will still be called twice:
 * https://react.dev/reference/react/useEffect#my-effect-runs-twice-when-the-component-mounts
 */
export default function useEffectOnce(callback: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
}
